import consumer from "../consumer"
import Rails from '@rails/ujs'

consumer.subscriptions.create("Marketing::ShowroomChannel", {
    // Called once when the subscription is created.
    initialized() {
	this.formdesk_capture = this.formdesk_capture.bind(this)
    },

    // Called when the subscription is ready for use on the server
    connected() {
	this.install()
    },

    // Called when the subscription has been terminated by the server
    disconnected() {
	this.uninstall()
    },

    // Called when there's incoming data on the websocket for this channel
    received(data) {
	let formdeskElement = document.querySelector("[data-sc-formdesk='" + data["formdesk_id"]  + "']")
	console.log(data)
	setTimeout(() => {
	    Rails.enableElement(formdeskElement.querySelector("input[type='submit']"))
	}, 500)
    },

    // Called when the subscription is rejected by the server.
    rejected() {
	this.uninstall()
    },

    formdesk_capture(event) {
	const formdeskElement = event.target.closest("[data-sc-formdesk]")
	if(formdeskElement) {
	    event.preventDefault()

	    let form = formdeskElement.querySelector("form")

	    if(form) {
		const method = form.method.toUpperCase()
		const url = form.action
		const enctype = form.enctype

		// Use FormData if it's available and needed
		let formdata
		let useFormData = enctype === "multipart/form-data" || form.querySelector('input[type="file"]')

		if (useFormData) {
		    formdata = new FormData(form)
		} else {
		    // fallback: URL-encoded serialization
		    formdata = new URLSearchParams(new FormData(form)).toString()
		}

		this.perform("formdesk_capture", { showroom_token: null, formdesk_id: formdeskElement.getAttribute('data-sc-formdesk'), formdata: formdata })
	    }
	}
    },

    install() {
	document.addEventListener("submit", this.formdesk_capture)
    },

    uninstall() {
	document.removeEventListener("submit", this.formdesk_capture)
    }
});
